package domain.model

data class ActionCard(
    val id: String,
    val title: String,
    val description: String,
    val url: String,
    val icon: String? = null,
    val showIcon: Boolean = true,
    val category: String = "general",
    val preview: String? = null
)
